import { Paper, Link, Stack, Avatar, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { NewRequestButton } from 'Images';

export const NewApplyButton = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Applies);

  return (
    <Link
      underline={'none'}
      color={'inherit'}
      href={`${process.env.REACT_APP_REDIRECT_URL}universalRequest`}
      width={'fit-content'}
      role='link'
    >
      <Paper
        sx={{
          backgroundColor: '#fff',
          border: '1px solid',
          borderColor: isDesktop ? 'primary.shade_200' : 'primary.shade_400',
          width: isDesktop ? '189px' : '102px',
          height: isDesktop ? '111px' : '100px',
          borderRadius: '8px',
          boxShadow: '0px 1px 20px 0px #081E541A',
        }}
      >
        <Stack
          direction={isDesktop ? 'row' : 'column'}
          gap={isDesktop ? '12px' : '0'}
          height={'100%'}
          alignItems={'center'}
          padding={isDesktop ? '12px 16px' : '18px 10px 12px 10px'}
        >
          <Avatar
            alt={''}
            src={NewRequestButton}
            sx={{
              width: isDesktop ? '40px' : '32px',
              height: isDesktop ? '40px' : '32px',
            }}
          />
          <Typography
            variant={'body5'}
            color={'text.secondary'}
            textAlign={isDesktop ? 'initial' : 'center'}
            width={'80px'}
          >
            {dictionary.makeNewRequest}
          </Typography>
        </Stack>
      </Paper>
    </Link>
  );
};
